import { cloneElement } from "react";

export function SocialIcon({
  href,
  icon,
}: {
  href: string;
  icon: React.ReactNode;
}) {
  return (
    <a
      href={href}
      className="border border-white dark:border-[#374151] rounded-full p-1.5 block hover:bg-white dark:hover:bg-[#374151] group shrink-0"
      target="_blank"
    >
      {cloneElement(icon as any, {
        className: "lg:w-4 lg:h-4 w-3 h-3 text-white dark:text-[#374151] dark:group-hover:text-white group-hover:text-black",
      })}
    </a>
  );
}
